"use strict";
/**
 * In-process TTL cache for RSS proxy incremental loading.
 * Best-effort on serverless (per-instance); repeated batch requests on a warm instance reuse work.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTtlCache = createTtlCache;
function createTtlCache(options) {
    const { ttlMs, maxKeys, staleMs = 0 } = options;
    const store = new Map();
    const inflight = new Map();
    const readStale = (key) => {
        if (staleMs <= 0)
            return undefined;
        const hit = store.get(key);
        if (!hit)
            return undefined;
        if (Date.now() <= hit.exp + staleMs)
            return hit.value;
        return undefined;
    };
    return {
        async getOrCreate(key, factory) {
            const now = Date.now();
            const hit = store.get(key);
            if (hit && hit.exp > now) {
                return hit.value;
            }
            const pending = inflight.get(key);
            if (pending) {
                return pending;
            }
            const p = factory()
                .then((value) => {
                if (store.size >= maxKeys) {
                    const first = store.keys().next().value;
                    if (first)
                        store.delete(first);
                }
                store.set(key, { value, exp: Date.now() + ttlMs });
                inflight.delete(key);
                return value;
            })
                .catch((e) => {
                inflight.delete(key);
                const stale = readStale(key);
                if (stale !== undefined)
                    return stale;
                throw e;
            });
            inflight.set(key, p);
            return p;
        },
    };
}
